import { Component, OnInit, Input } from '@angular/core';

import { GestorStatusService } from '../../gestor-status.service';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'app-lista-adquiridos',
  templateUrl: './lista-adquiridos.component.html',
  styleUrls: ['./lista-adquiridos.component.scss']
})
export class ListaAdquiridosComponent implements OnInit {

  @Input('producto') producto: string;
  @Input('productosFiltrados') productosFiltrados: any[];

  productosGenericos: any[] = [];

  prodSelected: number;

  constructor(
    private gestorStatService: GestorStatusService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.gestorStatService.mensajeActual.subscribe( (resu:any) => {
      this.productosFiltrados = resu;
      this.filtraProductos();
    });
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    // console.log(this.productosFiltrados);

  }

  filtraProductos(){
    switch(this.producto){
      case 'certify':
        this.productosFiltrados.forEach( (producto) => {
          let datosPro = {
            anio: producto.fechaCertificar,
            id: producto.idCertificar,
            completo: producto.completoCertificar
          };
          this.productosGenericos.push(datosPro);
        });
      break;
      case 'measurement':
        this.productosFiltrados.forEach( (producto) => {
          let datosPro = {
            anio: producto.fechaMedir,
            id: producto.idMedir,
            completo: producto.completoMedir
          };
          this.productosGenericos.push(datosPro);
        });
      break;
      case 'pulse':
        this.productosFiltrados.forEach( (producto) => {
          let datosPro = {
            anio: producto.fechaPulseCheck,
            id: producto.idPulseCheck,
            completo: producto.completoPulseCheck
          };
          this.productosGenericos.push(datosPro);
        });
      break;
    }
  }

  selProducto(anio:number){
    this.prodSelected = anio;
    this.gestorStatService.enviaAnioProd(this.prodSelected);
  }

}
